<template>
<div>
    <input type="text" id="txtUserName" v-model="userName" />
    <input type="text" id="txtEmail" v-model="email" />
    <input type="text" id="txtAddress" v-model="address" />
    <input type="text" id="txtCity" v-model="city" />
    <input type="text" id="txtCompany" v-model="company" />
    <input type="text" id="txtPosition" v-model="position" />
</div>
</template>

<script>
    
    import Utils from '../services/utils.js'
    import Config from '../services/config.js'
    import DataLayer from '../services/datalayer.js'

    export default {
        name: 'downloadForm',
        data () {
            return {
                userName: "",
                userId: "",
                email: "",
                address: "",
                city: "",
                company: "",
                position: "",
                buGuids: "",
                blGuids: "",
                buTags: "",
                blTags: "",
                currentItemId: "",
                campaignData: null
            }
        },
        mounted() {
            this.userName = Utils.getCookie("CLADownloadForm_User");
            if (this.userName.length == 0) this.userName = "Annonymous";
            this.userId = Utils.getCookie("CLAUserID");
            this.email = Utils.getCookie("CLADownloadForm_Email");
            var el = document.getElementById("page_hidBUGuids"); if (el) this.buGuids = el.value;
            el = document.getElementById("page_hidBLGuids"); if (el) this.blGuids = el.value;
            el = document.getElementById("page_hidBU"); if (el) this.buTags = el.value;
            el = document.getElementById("page_hidBL"); if (el) this.blTags = el.value;
            el = document.getElementById("page_hidCurrentItemID"); if (el) this.currentItemId = el.value;
        },
        methods: {
            recordDownload(id, url, successFnc, errorFnc) {
                if (this.address.length > 0 || this.city.length > 0) {
                    if (errorFnc) errorFnc({msg: "This functionality is not made available for robots."});
                    return;
                }
                this.campaignData = cla.component.analytics ? cla.component.analytics.getCampaignData() : undefined;
                var oThis = this;
                var postData = {
                    fileID: id,
                    fileURL: url,
                    userName: this.userName,
                    email: this.email,
                    position: this.position,
                    company: this.company,
                    borcan1: "",
                    borcan2: "",
                    context: "Document Finder",
                    currentItemID: "",
                    contactID: "",
                    cbNewsLetter: "no",
                    buGuids: this.buGuids,
                    buTags: this.buTags,
                    blGuids: this.blGuids,
                    blTags: this.blTags,
                    campaignName: this.campaignData ? this.campaignData.name : "",
                    campaignSource: this.campaignData ? this.campaignData.source : "",
                    campaignMedium: this.campaignData ? this.campaignData.medium : "",
                    campaignTerm: this.campaignData ? this.campaignData.term : "",
                    campaignContent: this.campaignData ? this.campaignData.content : "",
                    isCampaignLandingPage: this.campaignData ? this.campaignData.isLandingPage : false
                };
                DataLayer.recordDownload(postData).then(function(result) {
                    //GA event. This is the GA dataLayer
                    if (typeof (dataLayer) !== 'undefined') {
                        dataLayer.push({
                            'event': 'claEvent',
                            'description': 'File downloaded',
                            'value': url
                        });

                        console.log("Submitting GA event for download");
                        //new GA Event
                        //we rely on the page contact box existing
                        dataLayer.push({
                            'event': 'claEvent',
                            'description': 'V2 - File Download Recorded',
                            'businessunit': oThis.buTags,
                            'businessline': oThis.blTags,
                            'fileurl': url,
                            'context': window.location.pathname
                        });
                    }
                    if (successFnc) successFnc();
                }).catch(function (err) {
                    if (errorFnc) errorFnc(err);
                });
                
            }
        }
    }
</script>

<style scoped>

</style>
